import { useEffect, useState } from 'react'
import { Button, CircularProgress, MenuItem, Select, Typography } from '@mui/material'
import GoogleIcon from '@mui/icons-material/Google'
import { useTranslation } from 'react-i18next'
import { extractRootDomain } from '../../../utils/Utils'
import { projectsService } from '../../../services/ProjectsService'
import { useAccessToken } from '../../../hooks/useAccessToken'
import AddChartIcon from '@mui/icons-material/Addchart'

const ProjectSelector = ({model}) => {
  const { t } = useTranslation()
  const token = useAccessToken();

  useEffect(() => {
    if(!model.accounts){
      return
    }
    handleGetProjects(model.accounts[0].id)
  }, [])

  // Model
  const [ accountId, setAccountId ] = useState<string>('')
  const [ accountProjects, setAccountProjects] = useState<any>([])
  const [ projectSelected, setProjectSelected ] = useState<any>('')


  // controller
  const handleGetProjects = async ( id ) => {
    setAccountId(id)

    let data
    try {
      data = await projectsService.getProperties({ accessToken: token, id: id });
      if(data.length===0){
        setProjectSelected('')
        return
      }
    } catch (error) {
      setAccountProjects([]);
      setProjectSelected('')
    }

    const sitesToRemove = new Set(model.projects.map(item => extractRootDomain(item.property)));
    const filteredSites = data
      .filter(site => !sitesToRemove.has(extractRootDomain(site.siteUrl)))
      .sort((a, b) => a.siteUrl.localeCompare(b.siteUrl));

    setAccountProjects(filteredSites);
    setProjectSelected(filteredSites[0])
  }

  const handleClickAddProject = async () => {
    model.setIsLoading((prev) => ({ ...prev, projects: true }))
    const data = await projectsService.createProject({ id: accountId, property: projectSelected.siteUrl, accessToken: token });
    model.setProjectsDialogOpened(false)
    if (data) {
      const data = await projectsService.getProjects({ accessToken: token, id: accountId });
      model.setProjects(data);
      model.setIsLoading((prev) => ({ ...prev, projects: false }))
    }
  }

  //  View
  return (
    <>
      <Typography>{t('account')}</Typography>
      <Select
        label={t('account')}
        value={accountId || model.accounts && model.accounts[0].id}
        onChange={(event) => handleGetProjects(event.target.value)}
        fullWidth
      >
        {model.accounts?.map((account) => (
          <MenuItem key={account.id} value={account.id}>
            <GoogleIcon sx={{ color: 'red', mr: 1 }}/>{account.name}
          </MenuItem>
        ))}
      </Select>

      <Typography sx={{ mt: 3 }}>{t('project')}</Typography>
      <Select
        label={t('project')}
        value={projectSelected}
        onChange={(event) => setProjectSelected(event.target.value)}
        fullWidth
        disabled={model.isLoading.projects || projectSelected===undefined || projectSelected.length === 0}
        displayEmpty
        renderValue={(selected) => {
          if (!selected || Object.keys(selected).length === 0) {
            return <span style={{ color: '#aaa' }}>{t('accountWithoutProjects')}</span>;
          }
          return (
            <>
              <img src={`https://www.google.com/s2/favicons?sz=32&domain=${extractRootDomain(selected.siteUrl)}`} className='projectSelectorImg'
                   loading="lazy" alt="favicon" width={32} height={32} />
              {selected.siteUrl}
            </>
          )
        }}
      >
        {
          accountProjects?.map((site) => (
          <MenuItem key={site.siteUrl} value={site} >
            <img src={`https://www.google.com/s2/favicons?sz=32&domain=${extractRootDomain(site.siteUrl)}`} className='projectSelectorImg'
                 loading="lazy" alt="favicon" width={32} height={32} />
            {site.siteUrl}
          </MenuItem>
        ))}
      </Select>

      <Button
        variant="contained"
        className="btnAddProject"
        onClick={handleClickAddProject}
        disabled={model.isLoading.projects || projectSelected===undefined || projectSelected.length === 0}
        fullWidth
        startIcon={model.isLoading.projects ? <CircularProgress size={20} color="inherit" /> : <AddChartIcon />}
      >
        {t('add_projects')}
      </Button>
    </>
  )
}

export default ProjectSelector;